import $ from 'jquery';

const resetScrollAfterModalClose = () =>{
    if(document.querySelector('.modal')){
        $('.modal').on('show.bs.modal', function(ev){
            let modal = ev.target;
            modal.setAttribute('data-scroll-y', window.scrollY);

        })
        $('.modal').on('hidden.bs.modal', function(ev){
            let modal = ev.target;
            let scrollTo = modal.getAttribute('data-scroll-y');
            window.scrollTo({top: scrollTo*1, left: 0, behavior: "instant"});

        })
    }
}
export default resetScrollAfterModalClose;